/* eslint-disable import/no-default-export */
import { MockList } from '@graphql-tools/mock';
import Chance from 'chance';
import { v4 as createUuid } from 'uuid';

import availabilityOptions from './AvailabilityOptions';
import Candidate from './Candidate';
import Classification from './Classification';
import Credential from './Credential';
import DocumentDownloadLink from './DocumentDownloadLink';
import GenerateResumeFromProfilePayload from './GenerateResumeFromProfilePayload';
import Licence from './Licence';
import NextRolePreferredLocations from './NextRolePreferredLocations';
import NoticePeriod from './NoticePeriod';
import preferredClassificationOptions from './PreferredClassificationOptions';
import PreferredLocations2 from './PreferredLocations2';
import ProcessUploadedResumeResult from './ProcessUploadedResumeResult';
import ProfileScore from './ProfileScore';
import Qualification from './Qualification';
import RecommendedJob from './RecommendedJob';
import Resume from './Resume';
import RightToWork from './RightToWork';
import rightToWorkOptions from './RightToWorkOptions';
import Role from './Role';
import Salary from './Salary';
import salaryOptions from './SalaryOptions';
import SalaryPreference2 from './SalaryPreference2';
import SavedSearch from './SavedSearch';
import Skill from './Skill';
import Summary from './Summary';
import supportedCountries from './SupportedCountries';
import UnconfirmedData from './UnconfirmedData';
import UnconfirmedDataCompleted from './UnconfirmedDataCompleted';
import UnconfirmedDataPending from './UnconfirmedDataPending';
import workTypeOptions from './WorkTypeOptions';
import YearsOfExperience from './YearsOfExperience';
import KeywordSuggestion from './mockResolvers/searchKeywordSuggestions/createKeywordSuggestion';
import {
  OntologyCountry as IOntologyCountry,
  OntologyEducationProvider as IOntologyEducationProvider,
  OntologyOrganisation as IOntologyOrganisation,
  OntologyQualification as IOntologyQualification,
  OntologyRoleTitleSeniority as IOntologyRoleTitleSeniority,
  SuggestionHighlight,
} from './ontologySuggestions';
import SearchLocationSuggestions from './searchLocationSuggestions/SearchLocationSuggestions';
import LocationSuggestion from './searchLocationSuggestions/createLocationSuggestion';
const chance = new Chance();

const ID = chance.natural({ min: 10000000, max: 99999999 }).toString();

export const mocks = {
  Candidate,
  Classification,
  Credential,
  DocumentDownloadLink,
  GenerateResumeFromProfilePayload,
  LocationSuggestion,
  KeywordSuggestion,
  NextRolePreferredLocations,
  NoticePeriod,
  IOntologyCountry,
  IOntologyEducationProvider,
  IOntologyOrganisation,
  IOntologyQualification,
  IOntologyRoleTitleSeniority,
  Licence,
  PreferredLocations2,
  ProcessUploadedResumeResult,
  ProfileScore,
  Qualification,
  RightToWork,
  RecommendedJob,
  Resume,
  Role,
  Salary,
  SalaryPreference2,
  SavedSearch,
  SearchLocationSuggestions,
  Skill,
  SuggestionHighlight,
  Summary,
  UnconfirmedDataPending,
  UnconfirmedDataCompleted,
  UnconfirmedData,
  YearsOfExperience,
  Query: () => ({
    ontologyEducationProviders: () => new MockList([10, 10]),
    ontologyOrganisations: () => new MockList([10, 10]),
    ontologyRoleTitlesSeniority: () => new MockList([10, 10]),
    ontologyQualifications: () => new MockList([10, 10]),
    salaryOptions,
    rightToWorkOptions,
    availabilityOptions,
    workTypeOptions,
    preferredClassificationOptions,
    supportedCountries,
  }),
  Int: () => chance.natural({ min: 1, max: 2147483647 }),
  ID: () => ID,
  Email: () => chance.email(),
  UUID: () => createUuid(),
  DateTime: () => chance.date(),
};
